export default {
  title: 'Недвижимость в Кыргызстане',
  test: 'тест',
  button: {
    advert: {
      new: 'Создать объявление',
      complex: 'Добавить комплекс',
      company: 'Добавить компанию'
    },
    map: 'Показать на карте',
    adverts: 'Показать {count} объявлений'
  },
  menu: {
    link1: 'Аренда',
    link2: 'Продажа',
    link3: 'Новая недвижимость',
    link4: 'Коммерческая недвижимость',
    link5: 'Отдых на Иссык-куле'
  }
}
